import classes from './Element.module.css'
import ResponsePinViewer from './ResponsePinViewer'

function MeasurementViewer(props) {

    function getTextWidth(text, font) {
        // Create a canvas element
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        
        // Set the font for the context
        context.font = font;
        
        // Measure the width of the text
        const width = context.measureText(text).width;
        
        // Return the width
        return width;
    }

    let num_pins = props.max_num_pins;
    let height_pin_full = 35;
    let minHeight = 170;
    let height_measurement = (num_pins+1.25)*height_pin_full;
    height_measurement =height_measurement.toString() + 'px';
    minHeight = minHeight.toString() + 'px';


    let all_responses = (<></>);
    if (props.element.pins) {
        // let max_length_pinname = Math.max(props.element.pins.reduce((max, pin) => Math.max(max, getTextWidth(pin.name, '14px Roboto')), 0), getTextWidth('Factor', '14px Roboto')) ;
        let max_length_pinname = Math.max(props.element.pins.reduce((max, pin) => Math.max(max, getTextWidth(pin.name, '14px Roboto')), 0), 60) ;
        all_responses = props.element.pins.map((pin, pinIndex) => (
            <ResponsePinViewer id={props.elem_id+'_'+pinIndex} 
                         key={props.elem_id+'_'+pinIndex} 
                         name={pin.name}
                         max_length_pinname={max_length_pinname}/>
        ));
   
       
    }



    return (
        <>
            <div id='outer container' className={classes.outer_container} >
                <div id='measurement container out' className={`${classes.color_block_container} ${classes.red}`}>

                    <div id='measurement container' className={classes.upper_container} style ={{height: height_measurement, minHeight: minHeight}}>
                        <div id='main container' className={classes.upper_container_main} >
                            <div style={{height: '30px'}}></div>
                            <p className={classes.textareaviewer} style={{left:'24px'}} >
                                {props.element.name}
                            </p>
                        </div>
                        <div id='action_panel' className={classes.action_panel} >
                        </div>
                    </div>
                    <div className={classes.block_name}>Measurement</div>
                    <div id='footer_container' className={classes.footer_container}>
                    </div>
                </div>
                <div id='response container' className={classes.arrow_container} style = {{height: height_measurement, minHeight: minHeight}}>
                    {all_responses}
                </div>
            </div>
        </>);
     }

export default MeasurementViewer;